export const IDENTITY_ENDPOINT = 'https://auth.schoolify.ee';
// export const CHAT_ENDPOINT = 'https://fb6d-31-223-133-140.ngrok.io'

export const CHAT_ENDPOINT = process.env.REACT_APP_SOCKET_ENDPOINT;
export const SERVICES_ENDPOINT = process.env.REACT_APP_SERVICES_ENDPOINT;

export const SERVICE_ENDPOINT = process.env.REACT_APP_SERVICES_ENDPOINT;

export const SOCKET_ENDPOINT = process.env.REACT_APP_SOCKET_ENDPOINT;

export const GET_FIRST_ELEMENT_IN_ARRAY = 0;

export const USER_ROLES = {
  teacher: 'teacher',
  parent: 'parent',
  student: 'student',
};
